import { apiClient } from '../publicApiClient';
import type { SpaceSearchResult, SpaceSummary } from '../models/Space';
import { fromUrlFriendlyCity, toUrlFriendly, urlFriendlyEquals } from './urlUtils';

export interface ResolvedPublicSpace {
  cityName: string;
  searchResult: SpaceSearchResult;
  summary: SpaceSummary;
}

export async function resolvePublicSpaceBySlug(
  citySlug: string,
  spaceNameSlug: string,
  availableCities: string[] = [],
): Promise<ResolvedPublicSpace | null> {
  const cityName = fromUrlFriendlyCity(citySlug, availableCities);
  const spaces = await apiClient.searchSpaces(cityName);
  const searchResult = spaces.find((space) => urlFriendlyEquals(space.name, spaceNameSlug));

  if (!searchResult) {
    return null;
  }

  const summary = await apiClient.getSpaceSummary(searchResult.id);
  return {
    cityName,
    searchResult,
    summary,
  };
}

export function schoolTutorPagePath(city: string, spaceName: string): string {
  return `${spaceDetailPagePath(city, spaceName)}/tutors`;
}

/** Redirect target for legacy `/user/schools/:city/:spaceName` deep links. */
export function legacySchoolTutorRedirectPath(citySlug: string, spaceNameSlug: string): string {
  return `/user/search/${citySlug}/${spaceNameSlug}/tutors`;
}

export function spaceDetailPagePath(city: string, spaceName: string): string {
  return `/user/search/${toUrlFriendly(city)}/${toUrlFriendly(spaceName)}`;
}

export function roomBookPagePath(city: string, spaceName: string, roomName: string): string {
  return `${spaceDetailPagePath(city, spaceName)}/${toUrlFriendly(roomName)}/book`;
}

export function publicSpacePagePath(spaceId: string): string {
  return `/spaces/${spaceId}`;
}
